import { Link, useLocation, useRevalidator } from "react-router-dom";
import useAuth from "../../../../auth/hooks";
import { path as loginPath } from "../../../page-login";
import TransmedAnnouncement from "../../../../dtos/transmed/process/process/announcement";
import TransmedProcessSlide from "./slide";
import { Fragment, useState } from "react";
import { useSetError } from "../../../generic-error";
import UserService from "../../../../service/user";
import { CircularProgress } from "@mui/material";
import subtractOneSecond from "../../../../utils/subtractOneSecond";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfinity } from "@fortawesome/free-solid-svg-icons";

type PropsType = {
  periodText: string;
  announcement: TransmedAnnouncement | null;
  expired: boolean;
  transmedAvailable: boolean;
  existsRegistration: boolean;
};

function TransmedProcessAnnouncement(props: PropsType) {
  const auth = useAuth();
  const location = useLocation();

  const revalidaor = useRevalidator();
  const [loading, setLoading] = useState<boolean>(false);
  const setError = useSetError();

  return (
    <TransmedProcessSlide className="transmed-process-announcement">
      {!props.transmedAvailable && auth !== null ? (
        <div>
          {!auth.lc.transmed ? (
            <>
              <h3>Ne pare rău!</h3>
              <div>Din păcate {auth.lc.name} nu organizează transmed.</div>
            </>
          ) : !auth.is_medicine ? (
            <>
              <h3>Ne pare rău!</h3>
              <div>Transmed este disponibil doar stundeților la medicină.</div>
            </>
          ) : (
            <>
              <h3>Ne pare rău!</h3>
              <div>
                Transmed este disponibil doar începând din semestrul al doilea
                pentru studenții de anul 1.
              </div>
            </>
          )}
        </div>
      ) : (
        <>
          {props.expired && !props.existsRegistration ? (
            <h3>Următoarea ediție transmed urmează să înceapă în curând!</h3>
          ) : (
            <>
              <h4>Următoarea ediție transmed se va desfășura în perioada:</h4>
              <h1
                style={{
                  overflowWrap: "break-word",
                  wordBreak: "break-word",
                }}
              >
                {props.periodText}
              </h1>
            </>
          )}
          <div
            style={{
              alignSelf: "stretch",
              marginTop: "var(--gap-big)",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "var(--gap-xs)",
            }}
          >
            {auth === null ? (
              <>
                <div>
                  Pentru a{" "}
                  {props.expired
                    ? "fi notificat despre aceasta"
                    : "te putea înscrie"}{" "}
                  trebuie să fii autentificat
                </div>
                <Link
                  className="primary button"
                  to={((): string => {
                    const url = new URL(loginPath, window.location.origin);
                    url.searchParams.append(
                      "redirect",
                      location.pathname + location.search + location.hash,
                    );
                    return url.toString();
                  })()}
                >
                  Intră în cont
                </Link>
              </>
            ) : props.announcement === null ? (
              <>
                <div>
                  {auth.transmed_subscriber ? (
                    <>
                      Vei fi notificat prin e-mail atunci când se deschid
                      înscrierile.
                    </>
                  ) : (
                    <>
                      Abonează-te pentru a fi notificat prin e-mail când se
                      deschid înscrierile.
                    </>
                  )}
                </div>
                {!auth.transmed_subscriber && (
                  <button
                    type="button"
                    onClick={async () => {
                      setError("");
                      setLoading(true);
                      try {
                        await new UserService().update.subscribeTransmed();
                      } catch (e) {
                        setError(e);
                      } finally {
                        setLoading(false);
                        revalidaor.revalidate();
                      }
                    }}
                    className="primary button"
                  >
                    Abonează-te
                  </button>
                )}
                {(loading || revalidaor.state === "loading") && (
                  <CircularProgress />
                )}
              </>
            ) : (
              <>
                <div
                  className="surface"
                  style={{
                    alignSelf: "stretch",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "stretch",
                  }}
                >
                  <div
                    className="inline-scrollbar x"
                    style={{
                      flex: 1,
                      alignSelf: "stretch",
                      paddingBottom: "var(--surface-padding)",
                      width: "100%",
                    }}
                  >
                    <table style={{ width: "100%" }}>
                      <td
                        style={{
                          fontWeight: "bold",
                          marginBottom: "var(--gap-small)",
                        }}
                      >
                        Orașul
                      </td>
                      <td
                        style={{
                          fontWeight: "bold",
                          marginBottom: "var(--gap-small)",
                        }}
                      >
                        Locuri cu cazare
                      </td>
                      <td
                        style={{
                          fontWeight: "bold",
                          marginBottom: "var(--gap-small)",
                        }}
                      >
                        Locuri fără cazare
                      </td>
                      <td
                        style={{
                          fontWeight: "bold",
                          marginBottom: "var(--gap-small)",
                        }}
                      >
                        Perioada
                      </td>
                      {props.announcement.receivings.map((receiving) => (
                        <Fragment key={receiving.id}>
                          <td>{receiving.lc.city}</td>
                          <td style={{ fontWeight: 600 }}>
                            {receiving.accomodation_yes ?? (
                              <FontAwesomeIcon icon={faInfinity} />
                            )}
                          </td>
                          <td style={{ fontWeight: 600 }}>
                            {receiving.accomodation_no ?? (
                              <FontAwesomeIcon icon={faInfinity} />
                            )}
                          </td>
                          <td>
                            {receiving.exchange_start.getDate()}
                            {" " +
                              (receiving.exchange_start.getMonth() !==
                              receiving.exchange_end.getMonth()
                                ? new Intl.DateTimeFormat("ro-RO", {
                                    month: "short",
                                  }).format(receiving.exchange_start)
                                : "")}
                            {" - "}
                            {receiving.exchange_end.getDate()}{" "}
                            {new Intl.DateTimeFormat("ro-RO", {
                              month: "short",
                            }).format(receiving.exchange_end)}
                          </td>
                        </Fragment>
                      ))}
                    </table>
                  </div>
                </div>
                <div style={{ marginTop: "var(--gap-small)" }}>
                  Perioada de înscrieri:{" "}
                  <b>
                    {props.announcement.registration_start.toLocaleDateString(
                      "RO-ro",
                    )}
                    , ora{" "}
                    {props.announcement.registration_start.toLocaleTimeString(
                      "RO-ro",
                    )}{" "}
                    -{" "}
                    {subtractOneSecond(
                      props.announcement.registration_end,
                    ).toLocaleDateString("RO-ro")}
                    , ora{" "}
                    {subtractOneSecond(
                      props.announcement.registration_end,
                    ).toLocaleTimeString("RO-ro")}
                  </b>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </TransmedProcessSlide>
  );
}

export default TransmedProcessAnnouncement;
